// extracted by mini-css-extract-plugin
export var title = "phonepe-module--title--ca256";